import type { ViewerConfig } from '../types'

export const viewer: ViewerConfig = {
  cameraPosition: [39.94, 203.89, 428.13],
  minDistance: 200,
  maxDistance: 500,
  minAzimuthAngle: -Math.PI / 6,
  maxAzimuthAngle: Math.PI / 6,
  minPolarAngle: Math.PI / 2.5,
  maxPolarAngle: (85 * Math.PI) / 180,
  target: [48.99, 110.81, 61.24],
  getShadowManXPosition: (width: number) => -width / 2 - 50,
}
